import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import DatePicker from 'react-datepicker2';

export default class StuffInventoryTurnover extends Base {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            systemModuleId: 4,
            moduleAccessStatus: 1,
            filters: {
                priceMode: 2,
                stuffType: 1,
                fromDate: '',
                toDate: '',
                fromDateConverted: '',
                toDateConverted: '',
            },
            page: 1,
            per_page: 30,
            phrase: '',
            controllerName: 'report',
            menuId: 51
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;
                this.refreshData(null, 'stuff/inventoryturnover');
            });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">گردش موجودی کالاها</h3>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a onClick={e => this.refreshData(e, "stuff/inventoryturnover", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e, "stuff/inventoryturnover")}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.priceMode} className="form-control" onChange={e => this.state.filters.priceMode = parseInt(e.target.value)}>
                                                    <option value="2">میانگین</option>
                                                    <option value="3">FIFO</option>
                                                    <option value="4">LIFO</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.stuffType} className="form-control" onChange={e => this.state.filters.stuffType = parseInt(e.target.value)}>
                                                    <option value="1">کالا</option>
                                                    <option value="4">مواد اولیه</option>
                                                    <option value="3">محصولات تولید شده</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"از تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.fromDate = e;
                                                        this.state.filters.fromDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.fromDate)}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تا تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => {
                                                        this.state.filters.toDate = e;
                                                        this.state.filters.toDateConverted = this.convertMomentToDb(e)
                                                    }}
                                                    value={this.getFormatedDateForDatePicker(this.state.filters.toDate)}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e, "stuff/inventoryturnover")} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ ردیفی یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th><span className="sub-text text-center"></span></th>
                                                <th colSpan="3"><span className="sub-text text-center">موجودی ابتدای دوره</span></th>
                                                <th colSpan="3" style={{ "backgroundColor": "antiquewhite"} }><span className="sub-text text-center">خرید طی دوره</span></th>
                                                <th colSpan="3"><span className="sub-text text-center">موجودی آماده برای فروش</span></th>
                                                <th colSpan="3" style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">بهام تمام شده کالای فروش رفته</span></th>
                                                <th colSpan="3"><span className="sub-text text-center">موجودی پایان دوره</span></th>
                                            </tr>
                                            <tr>
                                                <th><span className="sub-text text-center">شرح</span></th>
                                                <th><span className="sub-text text-center">وزن</span></th>
                                                <th><span className="sub-text text-center">فی</span></th>
                                                <th><span className="sub-text text-center">مبلغ</span></th>

                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">وزن</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">فی</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">مبلغ</span></th>

                                                <th><span className="sub-text text-center">وزن</span></th>
                                                <th><span className="sub-text text-center">فی</span></th>
                                                <th><span className="sub-text text-center">مبلغ</span></th>

                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">وزن</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">فی</span></th>
                                                <th style={{ "backgroundColor": "antiquewhite" }}><span className="sub-text text-center">مبلغ</span></th>

                                                <th><span className="sub-text text-center">وزن</span></th>
                                                <th><span className="sub-text text-center">فی</span></th>
                                                <th><span className="sub-text text-center">مبلغ</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {this.state.data.records.map((record, index) =>
                                            <tr>
                                                <td>
                                                    <span className="sub-text text-center">{record.stuffName}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.startAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.startUnitPrice)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.startValue)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.buyAmount)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.buyUnitPrice)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.buyValue)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.readyAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.readyUnitPrice)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.readyValue)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.bahaAmount)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.bahaUnitPrice)}</span>
                                                </td>
                                                <td style={{ "backgroundColor": "antiquewhite" }}>
                                                    <span className="sub-text text-center">{this.money(record.bahaValue)}</span>
                                                </td>

                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.finalAmount)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.finalUnitPrice)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(record.finalValue)}</span>
                                                </td>

                                            </tr>
                                            )}
                                            <tr style={{ "background-color": "beige" }}>
                                                <td>
                                                    <b className="sub-text text-center">مجموع</b>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.startTotalW)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">*</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.startTotalP)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.buyTotalW)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">*</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.buyTotalP)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.readyTotalW)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">*</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.readyTotalP)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.bahaTotalW)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">*</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.bahaTotalP)}</span>
                                                </td>

                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.finalTotalW)}</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">*</span>
                                                </td>
                                                <td>
                                                    <span className="sub-text text-center">{this.money(this.state.data.finalTotalP)}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}